import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import { FormControl, FormGroup } from '@ngneat/reactive-forms';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

import { AddUserNoteForm } from 'dialog/add-user-note-dialog/add-user-note-dialog.model';
import { UserApplicationPort } from 'user/port/user-application.port';

@Injectable()
@UntilDestroy()
export class AddUserNoteDialogController {
	public i18n = 'presentation.app.common.dialog.addUserNote';

	public isAddUserNoteFormInvalid$: Observable<boolean>;
	public addUserNoteForm: FormGroup<AddUserNoteForm>;

	constructor(private _userApplicationPort: UserApplicationPort) {
		this.addUserNoteForm = new FormGroup<AddUserNoteForm>({
			note: new FormControl<string>('', { validators: [Validators.required] }),
		});

		this._initObservables();
	}

	public saveNote(coacheeId: string): Promise<void> {
		return this._userApplicationPort.createUserNote({
			targetId: coacheeId,
			note: this.addUserNoteForm.value.note,
		});
	}

	private _initObservables() {
		this.isAddUserNoteFormInvalid$ = this.addUserNoteForm.status$.pipe(
			map((status) => status === 'INVALID'),
			shareReplay({ bufferSize: 1, refCount: true })
		);
	}
}
